export async function exec<T>(promise: Promise<T>): Promise<[Awaited<T>, undefined | any]> {
  try {
    const result = await promise;
    return [result, undefined];
  } catch (error) {
    return [undefined!, error];
  }
}

export const noop = () => {};

/**
 * A Map wrapper that automatically initializes values when they are accessed. Avoids the need to check if a key exists before accessing it.
 */
export class AutoMap<K, V> extends Map<K, V> {
  constructor(private initializer: () => V) {
    super();
  }

  get(key: K): V {
    if (!this.has(key)) {
      this.set(key, this.initializer());
    }
    return super.get(key)!;
  }
}

export function getRandomId() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(2, 10);
}